<!--
Author: TangChen
Date: 2018-10-18
Desc: 现金宝优点
 -->
<template>
    <div :class="'bizcomp-currency-advantage bizcomp ' + className">
        <comp-title :title="title" />
        <el-row class="currency-advantage" :gutter="12">
            <el-col
                v-for="(advantage, index) in advantages"
                :key="index"
                :span="12"
                :class="{ marTop: index > 1 }"
            >
                <el-card shadow="hover">
                    <span>{{ advantage.tit }}</span>
                    <p>{{ advantage.text }}</p>
                    <div class="adv-img">
                        <img :src="require('../../assets/img/' + advantage.imgUrl)" alt="" />
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "CurrencyAdvantage",
    mixins: [mixin],
    data() {
        return {
            advantages: [
                {
                    tit: "1元钱起购，充值0费率",
                    text: "现金宝是一个能便捷管理您所有的银行卡的网络储蓄账户，免费开户，1元钱起存，存取无 任何手续费。",
                    imgUrl: "xjb-adv1.jpg"
                },
                {
                    tit: "风险较低，赚钱实实在在！",
                    text: "现金宝主要投资于高度流动性、安全性的短期货币工具， 不参与股票投资，与股市无直接联系，风险较低。",
                    imgUrl: "xjb-adv2.jpg"
                },
                {
                    tit: "T+0快速取现，最快1秒到账",
                    text: "支持T+0快速取现，最快1秒实时到账。单笔最高额度1万。资金随用随取，简单方便。 天天计息，节假日无休，日日复利！",
                    imgUrl: "xjb-adv3.jpg"
                },
                {
                    tit: "充值实时到账，现金宝买基金费率更低",
                    text: "现金宝充值实时到账，买基金费率更低，一键购买，投资更灵活。可以随时将现金宝转换 为收益更高的基金产品。",
                    imgUrl: "xjb-adv4.jpg"
                }
            ]
        };
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-currency-advantage {
    overflow: hidden;
    .marTop {
        margin-top: 13px;
    }
    .currency-advantage {
        .el-card {
            border: none;
        }
        .el-card .el-card__body {
            span {
                line-height: 40px;
                font-size: $f24;
                text-align: center;
                display: block;
                color: $color-b;
            }
            p {
                color: $text-color1;
                line-height: 26px;
            }
            .adv-img {
                text-align: center;
                height: 155px;
                padding-top: 24px;
            }
        }
    }
}
</style>
